import { useMemo } from "react";
import HealthSupplimentIcon from "../../../components/icons/HealthSupplimentIcon";
import CategoryFocusltem from "../../Organization/components/CategoryFocusltem";
import BeautyIcon from "../../../components/icons/BeautyIcon";
import FoodIcon from "../../../components/icons/FoodIcon";
import PetIcon from "../../../components/icons/PetIcon";

interface Props {
    data: any[]
}
const FocusCategory = (props: Props) => {
    const { data } = props;

    const categoriesList = useMemo(() => {
        return data?.map((item: any) => {
            switch (item?.focus_category) {
                case "Health Supplements":
                    return (
                        <CategoryFocusltem
                            key={item?.id}
                            title="Health Supplements"
                            icon={<HealthSupplimentIcon />}
                            items={item.sub_categories}
                        />

                    );

                case "Beauty & Skin":
                    return (
                        <CategoryFocusltem
                            key={item?.id}
                            title="Beauty & Skin"
                            icon={<BeautyIcon />}
                            items={item.sub_categories}
                        />

                    );

                case "Functional Food & Beverages":
                    return (
                        <CategoryFocusltem
                            key={item?.id}
                            title="Functional Food & Beverages"
                            icon={<FoodIcon />}
                            items={item.sub_categories}
                        />

                    );

                case "Pet Nutrition":
                    return (
                        <CategoryFocusltem
                            key={item?.id}
                            title="Pet Nutrition"
                            icon={<PetIcon />}
                            items={item.sub_categories}
                        />
                    );

                default:
                    return <></>
            }
        })
    }, [data])

    return (
        <div className="flex flex-col gap-y-[16px]">{categoriesList}</div>
    )
}

export default FocusCategory